import { ReactElement, useState, useEffect } from "react";
import { Button, Col, Drawer, Form, Input, Row, Select, Upload, message, Checkbox,Switch } from "antd";
import slugify from "react-slugify";
import { InboxOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import firebase from "firebase/app";
import { DrawerFooter } from "../../components/GlobalStyles";
import { CREATE_CATEGORY_REQUEST, FETCH_ALL_CATEGORY_REQUEST } from "../../redux/constants";
import { getUserState, getAuthState } from "../../redux/selectors";
import { countries, clubStatus, currencies } from "../../constants";

const { useForm } = Form;
const { Option } = Select;
const { TextArea } = Input;

type Props = {
  visible: boolean;
  onClose: () => void;
};

export function CreateCategoryDrawer({ visible, onClose }: Props): ReactElement {
    const dispatch = useDispatch();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const { t } = useTranslation();
    const storage = firebase.storage();
    const { currentUser } = useSelector(getAuthState);
    const [category, setCategory] = useState<any[]>([]);

    const getCategoryItems = async () => {
        const categoryList = await firebase.firestore().collection("category").where('parent', "==", 0).get();
        if(categoryList.size !== 0)
        {
            const list = categoryList.docs;
            const catList = list.map(cat => cat.data());
            setCategory(catList);
        }
    }

    useEffect(() => {
        getCategoryItems();
    }, []);

    const getCategoryID = async () => {
        const lastCateogrySnapshot = await firebase.firestore().collection("category").orderBy('catID', "desc").limit(1).get();
        
        if(lastCateogrySnapshot.size === 0) {
            return "001";
        }
        const { catID } = lastCateogrySnapshot.docs[0].data();
        const newCategoryId = parseInt(catID, 10) + 1;
        if(newCategoryId < 10 ) return `00${newCategoryId}`;
        if(newCategoryId > 9 && newCategoryId < 100) return `0${newCategoryId}`;
        return `${newCategoryId}`;
    }

    const onFinish = async (values: any) => {
        const categoryNum = await getCategoryID();
        const formValue = {
            ...values,
            parent : values.parent || 0,
            catID: categoryNum,
        }
        dispatch({ type: CREATE_CATEGORY_REQUEST, payload: formValue });
        dispatch({ type: FETCH_ALL_CATEGORY_REQUEST, payload: formValue });
        form.resetFields();
        setLoading(false);
        onClose();
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    

    return (
        <Drawer
            title={t("market.create_category")}
            width={420}
            onClose={onClose}
            visible={visible}
            bodyStyle={{ paddingBottom: 80 }}
        >
            <Form 
                form={form} 
                layout="vertical" 
                onFinish={onFinish} 
                onFinishFailed={onFinishFailed}
                initialValues={{
                }}
            >
                <Row gutter={24}>
                    <Col span={24}>
                        <Form.Item
                            name="name"
                            label={t("market.category_name")}
                            rules={[
                                {
                                required: true,
                                message: t("market.category_name_placeholder"),
                                },
                            ]}
                        >
                            <Input placeholder={t("market.category_name_placeholder")} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="keyword"
                            label={t("market.category_keyword")}
                            rules={[
                                {
                                required: true,
                                message: t("market.category_keyword_placeholder"),
                                },
                            ]}
                        >
                            <Input placeholder={t("market.category_keyword_placeholder")} />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            name="parent"
                            label={t("market.parent_category")}
                        >
                            <Select 
                                defaultValue={0}
                                placeholder={t("market.parent_category_placeholder")}>
                                <Option key={0} value={0}>None</Option>
                                { category.map(({name, catID}) => (
                                <Option key={catID} value={catID}>{name}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <DrawerFooter>
                    <Button onClick={onClose} style={{ marginRight: 8 }}>
                        {t("common.cancel")}
                    </Button>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        {t("common.submit")}
                    </Button>
                </DrawerFooter>
            </Form>
        </Drawer>
    );
}
